 const prodbaseURL = "https://knackhireapi.azurewebsites.net";
const devbaseURL = "https://assessnhireapidev.azurewebsites.net";
const prodfilebaseURL = "https://knackhireapi.azurewebsites.net/Resumes/JobPosting";
const devfilebaseURL = "https://assessnhireapidev.azurewebsites.net/Resumes/";

const localurl="https://localhost:44369";
// export const baseURL = localurl; 

const uiprodURL ="https://knackhire.azurewebsites.net"
const uidevURL ="https://assessnhiredev.azurewebsites.net"

const devguid = "c21d2f73-0e48-45d7-a19c-9223bf78a23c";
const prodguid = "cc9d452a-e2ce-4a2a-9154-14725ee7a3ea";

const uiwebhookprodURL ="https://quasivo.app.n8n.cloud/webhook/Knack-agent-DB"
const uiwebhookdevURL ="https://quasivo.app.n8n.cloud/webhook-test/Knack-agent-DB-DEV"


// export const baseURL = devbaseURL;
// export const siteURL = uidevURL;
// export const defaultguid = devguid;
// export const defaultfilebaseurl = devfilebaseURL;
// export const sitewebhookURL = uiwebhookdevURL;

export const baseURL = prodbaseURL;
export const siteURL = uiprodURL;
export const defaultguid = prodguid;
export const defaultfilebaseurl = prodfilebaseURL;
export const sitewebhookURL = uiwebhookprodURL;


// Local
// export const baseURL = localurl;
// export const siteURL = uidevURL;
// export const defaultguid = devguid;
// export const defaultfilebaseurl = devfilebaseURL;
// export const sitewebhookURL = uiwebhookdevURL;


export const transcribe ={APIURL : baseURL + "/api/Speech/transcribe",}
export const LoginAPIURL={ APIURL: baseURL + "/api/Account/Login", }
export const RegisterAPIURL={ APIURL: baseURL + "/api/Account/Register", }
export const VerifyEmailAPIURL={ APIURL: baseURL + "/api/Account/verify-email", }
export const ForgotpwdAPIURL={ APIURL: baseURL + "/api/Account/forgot-password", }
export const ResetpwdAPIURL={ APIURL: baseURL + "/api/Account/reset-password", }
export const GetCourseInfo={ APIURL: baseURL + "/api/Consultant/GetCourseInfo", }
 export const GetJobSeekerAndPublicSeekerProfile={ APIURL: baseURL + "/api/Account/verify-email", }
 export const AddBenchCandidatesProfile={ APIURL: baseURL + "/api/Consultant/AddBenchCandidatesProfile", }
 export const UpdateBenchCandidatesProfile={ APIURL: baseURL + "/api/Consultant/UpdateBenchCandidatesProfile", }
 export const GetCandidatesByConsultant={ APIURL: baseURL + "/api/Consultant/GetCandidatesByConsultant", }
 export const GetListOfBenchCandidates={ APIURL: baseURL + "/api/Employer/GetListOfBenchCandidates", }
 export const GetCandidateById={ APIURL: baseURL + "/api/Consultant/GetCandidateById", }
 export const GetFilterCandidates={ APIURL: baseURL + "/api/Employer/GetFilterCandidates", }
 export const AddEmployer={ APIURL: baseURL + "/api/Employer/AddEmployer", }
 export const UpdateEmployer={ APIURL: baseURL + "/api/Employer/UpdateEmployer", }
 export const GetEmployerByUserID={ APIURL: baseURL + "/api/Employer/GetEmployerByUserID", }
 export const AddConsultant={ APIURL: baseURL + "/api/Consultant/AddConsultant", }
 export const UpdateConsultant={ APIURL: baseURL + "/api/Consultant/UpdateConsultant", }
 export const GetConsultantByUserID={ APIURL: baseURL + "/api/Consultant/GetConsultantByUserID", }
 export const AddSelectedCandidates={ APIURL: baseURL + "/api/Employer/AddSelectedCandidates", }
 export const UploadSignature={ APIURL: baseURL + "/api/Employer/UploadSignature", }
 export const GetConsultantByConsultantID={ APIURL: baseURL + "/api/Consultant/GetConsultantByConsultantID", }
 export const GetListOfCandidatesByEmployerID={ APIURL: baseURL + "/api/Consultant/GetListOfCandidatesByEmployerID", }
 export const GetHireResourceByConsultantID={ APIURL: baseURL + "/api/Consultant/GetHireResourceByConsultantID", }
 export const GetHireResourceByCompanyID={ APIURL: baseURL + "/api/Employer/GetHireResourceByCompanyID", }
 export const GetHiredResourcesByUserID={ APIURL: baseURL + "/api/Consultant/GetHiredResourcesByUserID", }
 export const UpdateConsultantBondFile={ APIURL: baseURL + "/api/Consultant/UpdateConsultantBondFile", }
 export const UpdateConsultantLOGO={ APIURL: baseURL + "/api/Consultant/UpdateConsultantLOGO", }
 export const UpdateBenchCandidatesProfilePIC={ APIURL: baseURL + "/api/Consultant/UpdateBenchCandidatesProfilePIC", }
 export const UpdateBenchCandidatesProfileRESUME={ APIURL: baseURL + "/api/Consultant/UpdateBenchCandidatesProfileRESUME", }
 export const UpdateisHired={ APIURL: baseURL + "/api/Employer/UpdateConformisHired", }
 export const GetCandidateByCompanyID={ APIURL: baseURL + "/api/Employer/GetCandidateByCompanyID", }
 export const GetJobRoles={ APIURL: baseURL + "/api/HRinitialScreening/GetJobRoles", }
 export const AddCandidateIntSchDet={ APIURL: baseURL + "/api/HRinitialScreening/AddCandidateIntSchDet", }
 export const AddQuestionsList={ APIURL: baseURL + "/api/HRinitialScreening/AddQuestionsList", }
 export const HRinitialScreening={ APIURL: baseURL + "/api/HRinitialScreening/GetInterviewDetails", }
 export const GetAttemptedInterviewsByEmployer={ APIURL: baseURL + "/api/HRinitialScreening/GetAttemptedInterviewsByEmployer", }
 export const UpdateUsersInfo={ APIURL: baseURL + "/api/Account/UpdateUsersInfo", }
 export const GetUserDetailsByGuid={ APIURL: baseURL + "/api/Account/GetUserDetailsByGuid", }
 export const UpdateInterviewCandidateByID={ APIURL: baseURL + "/api/HRinitialScreening/UpdateInterviewCandidateByID", }
 export const GetScheduledCandidatebyid={ APIURL: baseURL + "/api/HRinitialScreening/GetScheduledCandidatebyid", }
 export const AddVendors={ APIURL: baseURL + "/api/HRinitialScreening/AddVendors", }
 export const GetListOfVendorsByEmployeeID={ APIURL: baseURL + "/api/HRinitialScreening/GetListOfVendorsByEmployeeID", }
 export const GetVendorsByVGuid={ APIURL: baseURL + "/api/HRinitialScreening/GetVendorsByVGuid", }
 export const UpdateVendorDetailsByID={ APIURL: baseURL + "/api/HRinitialScreening/UpdateVendorDetailsByID", }
 export const ShareLinkToVendor={ APIURL: baseURL + "/api/HRinitialScreening/ShareLinkToVendor", }
 export const GetCandidateById_Share={ APIURL: baseURL + "/api/Consultant/GetCandidateById_Share", }
 export const GetScheduledCandidatebyid_Share={ APIURL: baseURL + "/api/HRinitialScreening/GetScheduledCandidatebyid_Share", }
 export const GetListOfCandidatesByEmployerIDforCandidateList={ APIURL: baseURL + "/api/Consultant/GetListOfCandidatesByEmployerIDforCandidateList", }
 export const AddQuestions_BulkImport={ APIURL: baseURL + "/api/HRinitialScreening/AddQuestions_BulkImport", }
 export const GetListOfUsersByEmployeeID={ APIURL: baseURL + "/api/HRinitialScreening/GetListOfUsersByEmployeeID", }
 export const ReattemptInterview={ APIURL: baseURL + "/api/HRinitialScreening/ReattemptInterview", }
 export const ChangeUserStatus={ APIURL: baseURL + "/api/HRinitialScreening/ChangeUserStatus", }
 export const AddBenchCandidatesProfile_BulkImport={ APIURL: baseURL + "/api/Consultant/AddBenchCandidatesProfile_BulkImport", }
 export const GetTestTypes={ APIURL: baseURL + "/api/HRinitialScreening/GetTestTypes", }
 export const UpdateInterviewCandidateByID_Rating={ APIURL: baseURL + "/api/HRinitialScreening/UpdateInterviewCandidateByID_Rating", }
 export const GetInterviewQuestions={ APIURL: baseURL + "/api/HRinitialScreening/GetInterviewQuestions", }
 export const GetInterviewQuestionbyQuestionID={ APIURL: baseURL + "/api/HRinitialScreening/GetInterviewQuestionbyQuestionID", }
 export const UpdateQuestionsByQuestionID={ APIURL: baseURL + "/api/HRinitialScreening/UpdateQuestionsByQuestionID", }
 export const SaveCandidateRecordedVideo={ APIURL: baseURL + "/api/HRinitialScreening/SaveCandidateRecordedVideo", }
 export const PostAttemptedQuestions={ APIURL: baseURL + "/api/HRinitialScreening/PostAttemptedQuestions", }
 export const AddMaskingDetails={ APIURL: baseURL + "/api/HRinitialScreening/AddMaskingDetails", }
 export const GetMaskingDetailsById={ APIURL: baseURL + "/api/HRinitialScreening/GetMaskingDetailsById", }
 export const PostJobRoles={ APIURL: baseURL + "/api/HRinitialScreening/PostJobRoles", }
 export const UpdateJobRoleByID={ APIURL: baseURL + "/api/HRinitialScreening/UpdateJobRoleByID", }
 export const GetJobRoleByID={ APIURL: baseURL + "/api/HRinitialScreening/GetJobRoleByID", }
 export const Sendverificationcode={ APIURL: baseURL + "/api/HRinitialScreening/Sendverificationcode", }
 export const PostLeads={ APIURL: baseURL + "/api/HRinitialScreening/PostLeads", }
 export const UpdateLeadsByID={ APIURL: baseURL + "/api/HRinitialScreening/UpdateLeadsByID", }
 export const GetLeadByID={ APIURL: baseURL + "/api/HRinitialScreening/GetLeadByID", }
 export const GetAllLeads={ APIURL: baseURL + "/api/HRinitialScreening/GetAllLeads", }
 export const updateStatus={ APIURL: baseURL + "/api/Consultant/updateStatus", }
 export const SendMailToLeads={ APIURL: baseURL + "/api/HRinitialScreening/SendMailToLeads", }
 export const ReplicateBenchCandidatesProfileAPI = { APIURL: baseURL + "/api/Consultant/ReplicateBenchCandidatesProfile", }
 export const JobPosting ={APIURL : baseURL + "/api/HRinitialScreening/AddJobPosts",}
 export const GetJobPosts ={APIURL : baseURL +"/api/HRinitialScreening/GetJobPosting", }
 export const UpdateJobPosts ={APIURL : baseURL + "/api/HRinitialScreening/UpdateJobPosts", }
 export const GetJobPostsByID={APIURL : baseURL + "/api/HRinitialScreening/GetJobPostByID",}
 export const AddLeads_BulkImport={APIURL : baseURL + "/api/HRinitialScreening/AddLeads_BulkImport",}
 export const GetCountries={APIURL : baseURL + "/api/HRinitialScreening/GetCountries",}
 export const ChangeJobPostStatus={APIURL : baseURL + "/api/HRinitialScreening/ChangeJobPostStatus",} 
 export const DeleteRecorededVideo={APIURL : baseURL + "/api/HRinitialScreening/DeleteCandidateRecordedVideos",} 
 export const MoveFileFromAzureBlob={APIURL : baseURL + "/api/Upload/MoveFileFromAzureBlob",} 
  
//  export const GetAttemptedInterviewsByEmployer={ APIURL: localbaseURL + "/api/HRinitialScreening/GetAttemptedInterviewsByEmployer", }
//  export const DeleteRecorededVideo={APIURL : localbaseURL + "/api/HRinitialScreening/DeleteCandidateRecordedVideos",} 
export const TestSaveCandidateRecordedVideo={APIURL : baseURL + "/api/Test/SaveCandidateRecordedVideo",} 

export const GetHotList={ APIURL: baseURL + "/api/HRinitialScreening/GetHotList", }
export const PostHotList={ APIURL: baseURL + "/api/HRinitialScreening/AddHotList", }
export const UpdateHotList={ APIURL: baseURL + "/api/HRinitialScreening/UpdateHotList", }
export const GetHotListByID={ APIURL: baseURL + "/api/HRinitialScreening/GetHotListByID", }
export const AddHotList_BulkImport={APIURL : baseURL + "/api/HRinitialScreening/AddHotList_BulkImport",}
export const SendMailToHotList={ APIURL: baseURL + "/api/HRinitialScreening/SendMailToHotList", }
export const ChangeHotLsitStatus={APIURL : baseURL + "/api/HRinitialScreening/ChangeHotLsitStatus",}

export const DeleteFromGoogleDriveVideos={APIURL : baseURL + "/api/Upload/DeleteFromGoogleDrive",}
export const GetApprovedConsultants={APIURL : baseURL + "/api/Consultant/GetApprovedConsultants",}
export const UpdateCandidateClientStatus={APIURL : baseURL + "/api/Consultant/UpdateCandidateClientStatus",}
export const GetInterviewDetailWithOutQuns={APIURL : baseURL + "/api/HRinitialScreening/GetInterviewDetailWithOutQuns",}
export const GetClients={APIURL : baseURL + "/api/Client/GetClients",}
export const AddClients={APIURL : baseURL + "/api/Client/AddClients",}
export const UpdateClientById={APIURL : baseURL + "/api/Client/UpdateClientById",}
export const deactivateClientByClientId={APIURL : baseURL + "/api/Client/deactivateClientByClientId",}
export const SendMatchEmail={APIURL : baseURL + "/api/HRinitialScreening/SendMatchEmail",}
export const AddMatchedcandidateList={APIURL : baseURL + "/api/HRinitialScreening/AddMatchedcandidateList",}
export const GetMatchedcandidateList={APIURL : baseURL + "/api/HRinitialScreening/GetMatchedcandidateList",}
export const DeactivateQuestions={APIURL : baseURL + "/api/HRinitialScreening/DeactivateQuestions",}
export const DeactivateVendors ={APIURL : baseURL + "/api/HRinitialScreening/DeactivateVendors",}
export const DeActivateLeads ={APIURL : baseURL + "/api/HRinitialScreening/DeActivateLeads",}
export const GenerateContent ={APIURL : baseURL + "/api/gemini/GenerateContent",}
export const Searchfilter ={APIURL : baseURL + "/api/HRinitialScreening/Searchfilter",}
export const AddCodingIntQuns ={APIURL : baseURL + "/api/HRinitialScreening/AddCodingIntQuns",}
export const GetCountryIdOfUsers ={APIURL : baseURL + "/api/HRinitialScreening/GetCountryIdOfUsers",}
export const GetSubscriptionPlans ={APIURL : baseURL + "/api/HRinitialScreening/GetSubscriptionPlans",}
export const CreatePaymentIntent ={APIURL : baseURL + "/api/HRinitialScreening/create-payment-intent",}
export const AddSubscription ={APIURL : baseURL + "/api/HRinitialScreening/AddSubscription",}
export const GetUserSubscriptionDetails ={APIURL : baseURL + "/api/HRinitialScreening/GetUserSubscriptionDetails",}
export const SendCandidateemail ={APIURL : baseURL + "/api/HRinitialScreening/Send-CandidatePool-CandidateSubmissionMail",}
export const AddBenchCandidatesProfile_BulkImportwithDocs ={APIURL : baseURL + "/api/Consultant/AddBenchCandidatesProfile_BulkImportwithDocs",}
export const GetDocumentTypes={APIURL : baseURL + "/api/HRinitialScreening/GetDocumentTypes",}
export const search={APIURL : baseURL + "/api/Client/search",}
export const GetCandidatesByJobTitle={APIURL : baseURL + "/api/Consultant/GetCandidatesByJobTitle",}
export const SendJobDetailstoInternalLinkedinCandidates={APIURL : baseURL + "/api/Consultant/SendJobDetailstoInternalLinkedinCandidates",}
export const SubmitLinkedInUrls={APIURL : baseURL + "/api/Client/SubmitLinkedInUrls",}
export const getcallback={APIURL : baseURL + "/api/Client/getcallback",}
export const SendInternalBenchGeneralSharetoRecruiters={APIURL : baseURL + "/api/HRinitialScreening/Send-InternalBench-GeneralSharetoRecruiters",}
export const SendPostJobJobDetailsToBenchSalesOrCandidate={APIURL : baseURL + "/api/HRinitialScreening/Send-PostJob-JobDetailsToBenchSalesOrCandidate",}
export const SendPostJobRTRMail={APIURL : baseURL + "/api/HRinitialScreening/Send-PostJob-RTRMail",}
export const SendCandidatePoolRTRMail={APIURL : baseURL + "/api/HRinitialScreening/Send-CandidatePool-RTRMail",}
export const GetListOfUsersWithAdminByEmployeeID={APIURL : baseURL + "/api/HRinitialScreening/GetListOfUsersWithAdminByEmployeeID",}
export const InsertResourceDocs={APIURL : baseURL + "/api/Consultant/InsertResourceDocs",}
export const UpdateResourceDocs={APIURL : baseURL + "/api/Consultant/UpdateResourceDocs",}
export const GetResources={APIURL : baseURL + "/api/Consultant/GetResources",}
export const SendScreeningReminder={APIURL : baseURL + "/api/HRinitialScreening/SendScreeningReminder",}
 export const CustomEmail={APIURL : baseURL + "/api/HRinitialScreening/CustomEmail",}
 export const CustomBenchsalesEmail={APIURL : baseURL + "/api/HRinitialScreening/CustomBenchsalesEmail",}
 export const submittedCandidates={APIURL : baseURL + "/api/HRinitialScreening/submitted-candidates",}
 export const sendBenchCandidateSubmission={APIURL : baseURL + "/api/HRinitialScreening/Send-InternalBench-CandidateSubmissionMail",}
 export const generateToken={APIURL : baseURL + "/api/Jitsi/generate-token",}
 export const UpdateLeadOutreachStatus={APIURL : baseURL + "/api/HRinitialScreening/UpdateLeadOutreachStatus",}
 export const GetCandidateStats={APIURL : baseURL + "/api/Consultant/GetCandidateStats",}
export const GetBenchsaalesStats={APIURL : baseURL + "/api/Consultant/GetBenchsaalesStats",}
export const SendRelocationMail={APIURL : baseURL + "/api/HRinitialScreening/send-relocation-mail",}
 export const GetListOfAllVendorsByEmployeeID={ APIURL: baseURL + "/api/HRinitialScreening/GetListOfAllVendorsByEmployeeID", }
 export const SaveCandidateRecordedAudio={ APIURL: baseURL + "/api/Test/SaveCandidateRecordedAudio", }
  export const GetCandidateEvaluations={ APIURL: baseURL + "/api/HRinitialScreening/GetCandidateEvaluations", }
  export const GetbenchSalesSubmissions={ APIURL: baseURL + "/api/HRinitialScreening/GetbenchSalesSubmissions", }
  export const UpdateBenchsalesSubmissionStatus={ APIURL: baseURL + "/api/HRinitialScreening/UpdateBenchsalesSubmissionStatus", }
  export const DeleteBlob={ APIURL: baseURL + "/api/Consultant/DeleteBlob", }
  export const SaveBenchsalesSubmissions={ APIURL: baseURL + "/api/HRinitialScreening/SaveBenchsalesSubmissions", }
  export const UpdateLeadOutreachBulk={ APIURL: baseURL + "/api/HRinitialScreening/UpdateLeadOutreachBulk", }
    export const GetLatestPayrate={ APIURL: baseURL + "/api/HRinitialScreening/GetLatestPayrate", }
    export const ProfilesSearch={ APIURL: baseURL + "/api/Dice/ProfilesSearch", }
    export const Contact={ APIURL: baseURL + "/api/Dice/contact", }
    export const IntelliSearch={ APIURL: baseURL + "/api/Dice/IntelliSearch", }
        export const GetOverAllCandidateEvaluations={ APIURL: baseURL + "/api/HRinitialScreening/GetOverAllCandidateEvaluations", }
        export const GetCandidateOutreachdetails={ APIURL: baseURL + "/api/HRinitialScreening/GetCandidateOutreachdetails", }
        export const GetHotlistOutreach={ APIURL: baseURL + "/api/HRinitialScreening/GetHotlistOutreach", }
        export const suggest={ APIURL: baseURL + "/api/Client/suggest", }
export const JobOpportunitytoCandidate={ APIURL: baseURL + "/api/HRinitialScreening/JobOpportunitytoCandidate", }
export const GetCandidateByGuid={ APIURL: baseURL + "/api/Consultant/GetCandidateByGuid", }
export const GetCandidateSubmission={ APIURL: baseURL + "/api/Consultant/GetCandidateSubmission", }
export const AddCandidateSubmissions={ APIURL: baseURL + "/api/Consultant/AddCandidateSubmissions", }
export const UpdateCandidateSubmissions={ APIURL: baseURL + "/api/Consultant/UpdateCandidateSubmissions", }
export const CleanupSuppressedEmails={ APIURL: baseURL + "/api/HRinitialScreening/cleanup-suppressed-emails", }
export const DeleteCandidateSubmission={ APIURL: baseURL + "/api/Consultant/deleteCandidateSubmission", }
export const GetDashboardStats={ APIURL: baseURL + "/api/Consultant/GetDashboardStats", }
export const Credits={ APIURL: baseURL + "/api/Client/signalhire/credits", }

 

 export const rtrEmailTemplate = ({
  candidateName,
  jobTitle,
  location,
  jobType,
  jobDescription,
  candidateMobileNumber,
  senderEmail,
  billRate,
  submissionLink,
  recruiterName,
  endClientName
}) => `
  <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">
    <p>Dear ${recruiterName || candidateName || 'Candidate'},</p>

    <p>Greetings from <strong>KnackHook</strong>!</p>

    <p>It was nice talking with you.</p>

    <p>As discussed, please confirm the following details. Please Confirm the Rate with all the Documents like I-94 travel History, DL copy, And Visa Copy.</p>

    <p><strong>Candidate Name:</strong> ${candidateName}</p>
    <p><strong>Position Title:</strong> ${jobTitle}</p>
    <p><strong>Location:</strong> ${location}</p>
    <p><strong>Type:</strong> ${jobType}</p>
    <p><strong>Bill Rate & Payroll:</strong> ${billRate}</p>
     ${endClientName ? `<p><strong>Implementation/End Client:</strong> ${endClientName}</p>` : ""}


    <p><strong>Submission details:</strong></p>
   <table style="border-collapse: collapse; width: 50%;" border="1" cellspacing="0" cellpadding="8">
  <tr>
    <th style="border: 1px solid black; width: 50%;">Candidate Info</th>
    <th style="border: 1px solid black; width: 50%;">Details</th>
  </tr>
  <tr>
    <td style="border: 1px solid black; width: 50%;">Legal Name</td>
    <td style="border: 1px solid black; width: 50%;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Email</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Mobile Number</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Passport Number (Must)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Date of Birth (M/D)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">VISA</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  
  <tr>
    <td style="border: 1px solid black;">Current location</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Last 4 Digits of SSN</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Highest education</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">LinkedIn Profile</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Availability to interview</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Certifications</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Availability for Joining</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Relocation</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">References (2 Must)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
</table>

  <br/>
    <p><strong>NOTE:</strong><br />
    Rates once confirmed will not be re-negotiated at any stage (after confirming rate / after getting interview scheduled / after getting offer).<br />
    Any issues in the candidate delivery for this position will be taken seriously and legally.<br />
    ARTICLE IX – Misrepresentation & Proxy Interviews.
    <br /></p>
    The subcontractor agrees that the consultant or employee they present for a particular position is their own consultant and holds a valid work visa. The subcontractor also confirms that their consultant has not been submitted to the client directly or indirectly and will provide all required documents during the process.
    Any falsification regarding visa status or experience listed on the resume, if found to be non-genuine, gives the contractor the right to take action against the subcontractor. The subcontractor will be subject to liquidated damages as per the court of law.
    Furthermore, the subcontractor agrees and ensures that no one other than their submitted consultant will participate in interviews with the client. Proxy interviews or misrepresentation will cause irreparable damage to the relationship between KnackHook and its clients, and the subcontractor will be held responsible and subject to legal and financial penalties under the applicable laws.</p>

   <p><strong>Job Description:</strong></p>
    <p>${jobDescription}</p>
    <br/>
  
    <p>Best regards,<br />
    <strong>KnackHook Staffing Team,</strong><br />
    ✉️ <a href="mailto:${senderEmail}">${senderEmail},</a><br />
    📞 ${candidateMobileNumber}.<br /></p>
  </div>
`;
export const CandidateRTREmailTemplate = ({
  candidateName,
  jobTitle,
  location,
  jobType,
  jobDescription,
  candidateMobileNumber,
  senderEmail,
  billRate,
  submissionLink,
  recruiterName,
   endClientName,
}) => `
  <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">
    <p>Dear ${recruiterName || candidateName || 'Candidate'},</p>
 
    <p>Greetings from <strong>KnackHook</strong>!</p>
 
    <p>It was nice talking with you.</p>
 
    <p>As discussed, please confirm the following details. Please Confirm the Rate with all the Documents like I-94 travel History, DL copy, And Visa Copy.</p>
 
    <p><strong>Candidate Name:</strong> ${candidateName}</p>
    <p><strong>Position Title:</strong> ${jobTitle}</p>
    <p><strong>Location:</strong> ${location}</p>
    <p><strong>Type:</strong> ${jobType}</p>
    ${billRate ? `<p><strong>Bill Rate & Payroll:</strong> ${billRate}</p>` : ""}
 
    ${endClientName ? `<p><strong>Implementation/End Client:</strong> ${endClientName}</p>` : ""}
 
        <br/>
 
    <p><strong>Submission details:</strong></p>
   
 <table style="border-collapse: collapse; width: 50%;" border="1" cellspacing="0" cellpadding="8">
  <tr>
    <th style="border: 1px solid black; width: 50%;">Candidate Info</th>
    <th style="border: 1px solid black; width: 50%;">Details</th>
  </tr>
  <tr>
    <td style="border: 1px solid black; width: 50%;">Legal Name</td>
    <td style="border: 1px solid black; width: 50%;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Email</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Mobile Number</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Passport Number (Must)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Date of Birth (M/D)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">VISA</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">US Entry (VISA Type/Year)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Current location</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Last 4 Digits of SSN</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Highest education</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">LinkedIn Profile</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Availability to interview</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Certifications</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Availability for Joining</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">Relocation</td>
    <td style="border: 1px solid black;"></td>
  </tr>
  <tr>
    <td style="border: 1px solid black;">References (2 Must)</td>
    <td style="border: 1px solid black;"></td>
  </tr>
</table>
    <br/>
 <p><strong>NOTE:</strong><br />
    Rates once confirmed will not be re-negotiated at any stage (after confirming rate / after getting interview scheduled / after getting offer).<br />
    Any issues in the candidate delivery for this position will be taken seriously and legally.<br />
    ARTICLE IX – Misrepresentation & Proxy Interviews.
    <br /></p>
    The subcontractor agrees that the consultant or employee they present for a particular position is their own consultant and holds a valid work visa. The subcontractor also confirms that their consultant has not been submitted to the client directly or indirectly and will provide all required documents during the process.
    Any falsification regarding visa status or experience listed on the resume, if found to be non-genuine, gives the contractor the right to take action against the subcontractor. The subcontractor will be subject to liquidated damages as per the court of law.
    Furthermore, the subcontractor agrees and ensures that no one other than their submitted consultant will participate in interviews with the client. Proxy interviews or misrepresentation will cause irreparable damage to the relationship between KnackHook and its clients, and the subcontractor will be held responsible and subject to legal and financial penalties under the applicable laws.</p>
 
     <p><strong>Job Description:</strong></p>
     <p>${jobDescription}</p>
 
    <p>Best regards,<br />
    <strong>KnackHook Staffing Team,</strong><br />
     ✉️ <a href="mailto:${senderEmail}">${senderEmail},</a><br />
    📞 ${candidateMobileNumber}.<br />
   </p>
  </div>
`;
 


export const jobDetailsEmailTemplate = ({
  candidateName,
  jobTitle,
  location,
  jobType,
  jobDescription,
  candidateMobileNumber,
  senderEmail,
  endClientName

}) => `
  <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">
    <p>Dear ${candidateName || 'Candidate'},</p>

    <p>Hope you're doing well!</p>

    <p>We are pleased to inform you that your profile closely matches an exciting job opportunity with one of our esteemed clients. Kindly review the details below and respond with your updated resume so we can discuss the next steps.</p>
   <br/>
    <div style="border: 1px solid #f0ad4e; background: #fcf8e3; padding: 10px; margin: 15px 0; border-radius: 6px;">
      <strong>Note:</strong>
      <ul style="margin: 8px 0 0 20px; padding: 0;">
        <li><strong>Passport number and LinkedIn URL are mandatory</strong> for submission; please ensure these details are included.</li>
        <li><strong>Candidates without passport details will not be considered. However, citizens are exempt,</strong>,so please do not share profiles without passport details for non-citizens.</li>
        <li>If the JD specifies <strong>"Locals only"</strong>, do not share relocation or non-local profiles.</li>
        <li><strong>Do not make calls</strong>; we will review all profiles and will reply or contact you if a profile aligns with the requirement.</li>
      </ul>
    </div>
       <br/>

    <p><strong>Job Title:</strong> ${jobTitle}</p>
    <p><strong>Location:</strong> ${location}</p>
    <p><strong>Type:</strong> ${jobType}</p>

    <p><strong>Description:</strong></p>
    <p>${jobDescription}</p>
${endClientName ? `<!-- <p><strong>Implementation/End Client:</strong> ${endClientName}</p> -->` : ""}
    <p>Please share your updated resume by replying to this email.Looking forward to hearing from you!</p>

    <p>Best regards,<br />
   KnackHook Staffing Team,<br />   
   ✉️ ${senderEmail}, <br /> 
   📞 ${candidateMobileNumber}.</p>
  </div>
`;

export const screeningReminderEmailTemplate = ({
  candidateName,
  companyName,
  testDate,
  testTime,
  numberOfQuestions,
  testMode
}) => `
  <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">
    <h2 style="color:#1a73e8;">Online Screening Test - ${companyName}</h2>

    <p>Dear ${candidateName || 'Candidate'},</p>

    <p>This is a reminder for your upcoming online initial screening test with <strong>${companyName}</strong>.</p>

    <div style="background-color:#f1f3f4; padding:15px; border-radius:8px; margin: 15px 0;">
      <p><strong>Date:</strong> ${testDate}</p>
      <p><strong>Time:</strong> ${testTime}</p>
      <p><strong>Number of Questions:</strong> ${numberOfQuestions}</p>
      <p><strong>Mode:</strong> ${testMode}</p>
    </div>

    <p>🔔 Please ensure you have a stable internet connection and complete the test on time.</p>

    <p>Best regards,<br/>${companyName} Team</p>
  </div>
`;


export const jobDetailsEmailTemplatefromJobPosts = ({
  candidateName,
  jobTitle,
  location,
  jobType,
  jobDescription,
  candidateMobileNumber,
  senderEmail, 
endClientName,
billRate
}) => `
  <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">
    <p>Dear ${candidateName || 'Candidate'},</p>

    <p>Hope you're doing well!</p>

    <p>We’re excited to share a list of our current <strong> open job opportunities</strong> from <strong>KnackHook</strong>. These positions are actively hiring, and we’d love to collaborate with you in finding the best-fit candidates.</p>
<br/>
    <div style="border: 1px solid #f0ad4e; background: #fcf8e3; padding: 10px; margin: 15px 0; border-radius: 6px;">
      <strong>Note:</strong>
      <ul style="margin: 8px 0 0 20px; padding: 0;">
        <li><strong>Passport number and LinkedIn URL are mandatory</strong> for submission; please ensure these details are included.</li>
        <li><strong>Candidates without passport details will not be considered. However, citizens are exempt,</strong>,so please do not share profiles without passport details for non-citizens.</li>
        <li>If the JD specifies <strong>"Locals only"</strong>, do not share relocation or non-local profiles.</li>
        <li><strong>Do not make calls</strong>; we will review all profiles and will reply or contact you if a profile aligns with the requirement.</li>
      </ul>
    </div>
       <br/>
    <p><strong>Job Title:</strong> ${jobTitle}</p>
    <p><strong>Location:</strong> ${location}</p>
    <p><strong>Type:</strong> ${jobType}</p>
    ${billRate ? `<!--<p><strong>Bill Rate & Payroll:</strong> ${billRate}</p>  -->` : ""}
${endClientName ? `<!-- <p><strong>Implementation/End Client:</strong> ${endClientName}</p> -->` : ""}    <p><strong> Job Description:</strong></p>
    <p>${jobDescription}</p>

    <p>If you have strong candidates who match any of these roles, feel free to share their profiles with us. We’d love to connect and move forward quickly.</p>

    <p>Best Regards,<br />
   KnackHook Staffing Team,<br />   
   ✉️ ${senderEmail}, <br /> 
   📞 ${candidateMobileNumber}.</p>
  </div>
`;

 export const usStates = [
 
   { value: "", label: "Select State" },
 
   { value: "Alabama - AL", label: "Alabama - AL" },
 
   { value: "Alaska - AK", label: "Alaska - AK" },
 
   { value: "Arizona - AZ", label: "Arizona - AZ" },
 
   { value: "Arkansas - AR", label: "Arkansas - AR" },
 
   { value: "California - CA", label: "California - CA" },
 
   { value: "Colorado - CO", label: "Colorado - CO" },
 
   { value: "Connecticut - CT", label: "Connecticut - CT" },
 
   { value: "Delaware - DE", label: "Delaware - DE" },
 
   { value: "District of Columbia - DC", label: "District of Columbia - DC" },
 
   { value: "Florida - FL", label: "Florida - FL" },
 
   { value: "Georgia - GA", label: "Georgia - GA" },
 
   { value: "Hawaii - HI", label: "Hawaii - HI" },
 
   { value: "Idaho - ID", label: "Idaho - ID" },
 
   { value: "Illinois - IL", label: "Illinois - IL" },
 
   { value: "Indiana - IN", label: "Indiana - IN" },
 
   { value: "Iowa - IA", label: "Iowa - IA" },
 
   { value: "Kansas - KS", label: "Kansas - KS" },
 
   { value: "Kentucky - KY", label: "Kentucky - KY" },
 
   { value: "Louisiana - LA", label: "Louisiana - LA" },
 
   { value: "Maine - ME", label: "Maine - ME" },
 
   { value: "Maryland - MD", label: "Maryland - MD" },
 
   { value: "Massachusetts - MA", label: "Massachusetts - MA" },
 
   { value: "Michigan - MI", label: "Michigan - MI" },
 
   { value: "Minnesota - MN", label: "Minnesota - MN" },
 
   { value: "Mississippi - MS", label: "Mississippi - MS" },
 
   { value: "Missouri - MO", label: "Missouri - MO" },
 
   { value: "Montana - MT", label: "Montana - MT" },
 
   { value: "Nebraska - NE", label: "Nebraska - NE" },
 
   { value: "Nevada - NV", label: "Nevada - NV" },
 
   { value: "New Hampshire - NH", label: "New Hampshire - NH" },
 
   { value: "New Jersey - NJ", label: "New Jersey - NJ" },
 
   { value: "New Mexico - NM", label: "New Mexico - NM" },
 
   { value: "New York - NY", label: "New York - NY" },
 
   { value: "North Carolina - NC", label: "North Carolina - NC" },
 
   { value: "North Dakota - ND", label: "North Dakota - ND" },
 
   { value: "Ohio - OH", label: "Ohio - OH" },
 
   { value: "Oklahoma - OK", label: "Oklahoma - OK" },
 
   { value: "Oregon - OR", label: "Oregon - OR" },
 
   { value: "Pennsylvania - PA", label: "Pennsylvania - PA" },
 
   { value: "Rhode Island - RI", label: "Rhode Island - RI" },
 
   { value: "South Carolina - SC", label: "South Carolina - SC" },
 
   { value: "South Dakota - SD", label: "South Dakota - SD" },
 
   { value: "Tennessee - TN", label: "Tennessee - TN" },
 
   { value: "Texas - TX", label: "Texas - TX" },
 
   { value: "Utah - UT", label: "Utah - UT" },
 
   { value: "Vermont - VT", label: "Vermont - VT" },
 
   { value: "Virginia - VA", label: "Virginia - VA" },
 
   { value: "Washington - WA", label: "Washington - WA" },
 
   { value: "West Virginia - WV", label: "West Virginia - WV" },
 
   { value: "Wisconsin - WI", label: "Wisconsin - WI" },
 
   { value: "Wyoming - WY", label: "Wyoming - WY" },
 
   // Territories
 
   { value: "Puerto Rico - PR", label: "Puerto Rico - PR" },
 
   { value: "Guam - GU", label: "Guam - GU" },
 
   { value: "U.S. Virgin Islands - VI", label: "U.S. Virgin Islands - VI" },
 
   { value: "American Samoa - AS", label: "American Samoa - AS" },
 
   { value: "Northern Mariana Islands - MP", label: "Northern Mariana Islands - MP" },
 
 ];

export const usStateCities = {
  "Alabama - AL": [
    "Birmingham", "Montgomery", "Mobile", "Huntsville", "Tuscaloosa",
    "Hoover", "Dothan", "Auburn", "Decatur", "Madison",
    "Florence", "Gadsden", "Phenix City", "Prattville", "Vestavia Hills",
    "Alabaster", "Opelika", "Enterprise", "Homewood", "Other"
  ],
  "Alaska - AK": [
    "Anchorage", "Fairbanks", "Juneau", "Sitka", "Ketchikan",
    "Wasilla", "Kenai", "Kodiak", "Bethel", "Palmer",
    "Homer", "Soldotna", "Nome", "Kotzebue", "Seward",
    "Valdez", "Petersburg", "Barrow", "Wrangell", "Other"
  ],
  "Arizona - AZ": [
    "Phoenix", "Tucson", "Mesa", "Chandler", "Scottsdale",
    "Glendale", "Gilbert", "Tempe", "Peoria", "Surprise",
    "Yuma", "Avondale", "Goodyear", "Flagstaff", "Buckeye",
    "Lake Havasu City", "Casa Grande", "Sierra Vista", "Maricopa", "Other"
  ],
  "Arkansas - AR": [
    "Little Rock", "Fort Smith", "Fayetteville", "Springdale", "Jonesboro",
    "North Little Rock", "Conway", "Rogers", "Pine Bluff", "Bentonville",
    "Hot Springs", "Sherwood", "Texarkana", "Russellville", "Paragould",
    "Cabot", "Searcy", "West Memphis", "Bryant", "Other"
  ],
  "California - CA": [
    "Los Angeles", "San Diego", "San Jose", "San Francisco", "Fresno",
    "Sacramento", "Long Beach", "Oakland", "Bakersfield", "Anaheim",
    "Riverside", "Stockton", "Irvine", "Chula Vista", "Santa Ana",
    "Fremont", "San Bernardino", "Modesto", "Oxnard", "Other"
  ],
  "Colorado - CO": [
    "Denver", "Colorado Springs", "Aurora", "Fort Collins", "Lakewood",
    "Thornton", "Arvada", "Westminster", "Pueblo", "Centennial",
    "Boulder", "Greeley", "Longmont", "Loveland", "Broomfield",
    "Castle Rock", "Commerce City", "Parker", "Littleton", "Other"
  ],
    "Connecticut - CT": [
    "Bridgeport", "New Haven", "Stamford", "Hartford", "Waterbury",
    "Norwalk", "Danbury", "New Britain", "West Hartford", "Greenwich",
    "Fairfield", "Bristol", "Meriden", "Manchester", "West Haven",
    "Milford", "Stratford", "East Hartford", "Middletown", "Other"
  ],
  "Delaware - DE": [
    "Wilmington", "Dover", "Newark", "Middletown", "Smyrna",
    "Milford", "Seaford", "Georgetown", "Elsmere", "New Castle",
    "Claymont", "Bear", "Hockessin", "Glasgow", "Pike Creek",
    "Brookside", "Ocean View", "Laurel", "Lewes", "Other"
  ],
  "District of Columbia - DC": [
    "Washington D.C.", "Adams Morgan", "Capitol Hill", "Dupont Circle", "Foggy Bottom",
    "Georgetown", "Logan Circle", "Navy Yard", "NoMa", "Shaw",
    "Columbia Heights", "Petworth", "U Street Corridor", "Cleveland Park", "Brookland",
    "Friendship Heights", "Southwest Waterfront", "Tenleytown", "Woodley Park", "Other"
  ],
  "Florida - FL": [
    "Jacksonville", "Miami", "Tampa", "Orlando", "St. Petersburg",
    "Hialeah", "Tallahassee", "Fort Lauderdale", "Port St. Lucie", "Cape Coral",
    "Pembroke Pines", "Hollywood", "Gainesville", "Coral Springs", "Miami Gardens",
    "Clearwater", "Palm Bay", "West Palm Beach", "Lakeland", "Other"
  ],
  "Georgia - GA": [
    "Atlanta", "Augusta", "Columbus", "Macon", "Savannah",
    "Athens", "Sandy Springs", "Roswell", "Johns Creek", "Albany",
    "Warner Robins", "Alpharetta", "Marietta", "Valdosta", "Smyrna",
    "Dunwoody", "Rome", "East Point", "Milton", "Other"
  ],
   "Hawaii - HI": [
    "Honolulu", "Pearl City", "Hilo", "Kailua", "Waipahu",
    "Kaneohe", "Mililani", "Ewa Beach", "Kihei", "Makakilo",
    "Kahului", "Wahiawa", "Schofield Barracks", "Wailuku", "Kapolei",
    "Halawa", "Ocean Pointe", "Waimalu", "Royal Kunia", "Other"
  ],
  "Idaho - ID": [
    "Boise", "Meridian", "Nampa", "Idaho Falls", "Pocatello",
    "Caldwell", "Coeur d'Alene", "Twin Falls", "Lewiston", "Post Falls",
    "Rexburg", "Eagle", "Moscow", "Kuna", "Ammon",
    "Chubbuck", "Burley", "Mountain Home", "Blackfoot", "Other"
  ],
  "Illinois - IL": [
    "Chicago", "Aurora", "Naperville", "Joliet", "Rockford",
    "Springfield", "Peoria", "Elgin", "Waukegan", "Cicero",
    "Champaign", "Bloomington", "Arlington Heights", "Evanston", "Schaumburg",
    "Decatur", "Bolingbrook", "Palatine", "Skokie", "Other"
  ],
  "Indiana - IN": [
    "Indianapolis", "Fort Wayne", "Evansville", "South Bend", "Carmel",
    "Fishers", "Bloomington", "Hammond", "Gary", "Lafayette",
    "Muncie", "Noblesville", "Terre Haute", "Kokomo", "Anderson",
    "Greenwood", "Elkhart", "Mishawaka", "Lawrence", "Other"
  ],
  "Iowa - IA": [
    "Des Moines", "Cedar Rapids", "Davenport", "Sioux City", "Iowa City",
    "Waterloo", "Ames", "West Des Moines", "Council Bluffs", "Ankeny",
    "Dubuque", "Urbandale", "Cedar Falls", "Marion", "Bettendorf",
    "Mason City", "Marshalltown", "Fort Dodge", "Ottumwa", "Other"
  ],
  "Kansas - KS": [
    "Wichita", "Overland Park", "Kansas City", "Olathe", "Topeka",
    "Lawrence", "Shawnee", "Manhattan", "Lenexa", "Salina",
    "Hutchinson", "Leavenworth", "Leawood", "Garden City", "Dodge City",
    "Emporia", "Derby", "Prairie Village", "Pittsburg", "Other"
  ],
  "Kentucky - KY": [
    "Louisville", "Lexington", "Bowling Green", "Owensboro", "Covington",
    "Richmond", "Georgetown", "Florence", "Hopkinsville", "Nicholasville",
    "Elizabethtown", "Henderson", "Frankfort", "Paducah", "Independence",
    "Radcliff", "Ashland", "Madisonville", "Erlanger", "Other"
  ],
  "Louisiana - LA": [
    "New Orleans", "Baton Rouge", "Shreveport", "Lafayette", "Lake Charles",
    "Kenner", "Bossier City", "Monroe", "Alexandria", "Houma",
    "Marrero", "New Iberia", "Laplace", "Slidell", "Prairieville",
    "Central", "Terrytown", "Ruston", "Sulphur", "Other"
  ],
    "Maine - ME": [
    "Portland", "Lewiston", "Bangor", "South Portland", "Auburn",
    "Biddeford", "Sanford", "Saco", "Westbrook", "Augusta",
    "Waterville", "Brunswick", "Scarborough", "Orono", "Falmouth",
    "Presque Isle", "Bath", "Old Town", "Ellsworth", "Other"
  ],
  "Maryland - MD": [
    "Baltimore", "Columbia", "Germantown", "Silver Spring", "Waldorf",
    "Ellicott City", "Frederick", "Dundalk", "Rockville", "Gaithersburg",
    "Bethesda", "Bowie", "Towson", "Aspen Hill", "Severn",
    "Wheaton", "North Bethesda", "Bel Air South", "Hagerstown", "Other"
  ],
  "Massachusetts - MA": [
    "Boston", "Worcester", "Springfield", "Cambridge", "Lowell",
    "Brockton", "Quincy", "Lynn", "Newton", "Fall River",
    "Lawrence", "Somerville", "Framingham", "Haverhill", "Waltham",
    "Malden", "Brookline", "Plymouth", "Medford", "Other"
  ],
  "Michigan - MI": [
    "Detroit", "Grand Rapids", "Warren", "Sterling Heights", "Ann Arbor",
    "Lansing", "Dearborn", "Livonia", "Troy", "Westland",
    "Farmington Hills", "Kalamazoo", "Flint", "Rochester Hills", "Southfield",
    "Taylor", "Pontiac", "St. Clair Shores", "Royal Oak", "Other"
  ],
  "Minnesota - MN": [
    "Minneapolis", "Saint Paul", "Rochester", "Duluth", "Bloomington",
    "Brooklyn Park", "Plymouth", "Maple Grove", "Woodbury", "St. Cloud",
    "Eagan", "Eden Prairie", "Burnsville", "Coon Rapids", "Blaine",
    "Lakeville", "Minnetonka", "Apple Valley", "Edina", "Other"
  ],
  "Mississippi - MS": [
    "Jackson", "Gulfport", "Southaven", "Biloxi", "Hattiesburg",
    "Olive Branch", "Tupelo", "Meridian", "Greenville", "Horn Lake",
    "Pearl", "Madison", "Clinton", "Starkville", "Columbus",
    "Vicksburg", "Pascagoula", "Brandon", "Oxford", "Other"
  ],
  "Missouri - MO": [
    "Kansas City", "St. Louis", "Springfield", "Columbia", "Independence",
    "Lee's Summit", "O'Fallon", "St. Joseph", "St. Charles", "St. Peters",
    "Blue Springs", "Florissant", "Joplin", "Chesterfield", "Jefferson City",
    "Cape Girardeau", "Wildwood", "University City", "Liberty", "Other"
  ],
  "Montana - MT": [
    "Billings", "Missoula", "Great Falls", "Bozeman", "Butte",
    "Helena", "Kalispell", "Havre", "Anaconda", "Miles City",
    "Belgrade", "Livingston", "Laurel", "Whitefish", "Lewistown",
    "Sidney", "Glendive", "Hamilton", "Polson", "Other"
  ],
  "Nebraska - NE": [
    "Omaha", "Lincoln", "Bellevue", "Grand Island", "Kearney",
    "Fremont", "Hastings", "Norfolk", "Columbus", "Papillion",
    "La Vista", "Scottsbluff", "South Sioux City", "Beatrice", "North Platte",
    "Lexington", "Alliance", "Gretna", "York", "Other"
  ],
  "Nevada - NV": [
    "Las Vegas", "Henderson", "Reno", "North Las Vegas", "Sparks",
    "Carson City", "Elko", "Mesquite", "Boulder City", "Fernley",
    "Fallon", "Winnemucca", "Ely", "Pahrump", "Tonopah",
    "Stateline", "Incline Village", "Laughlin", "West Wendover", "Other"
  ],
  "New Hampshire - NH": [
    "Manchester", "Nashua", "Concord", "Derry", "Dover",
    "Rochester", "Keene", "Portsmouth", "Laconia", "Claremont",
    "Lebanon", "Somersworth", "Hanover", "Berlin", "Exeter",
    "Hooksett", "Milford", "Hudson", "Goffstown", "Other"
  ],
  "New Jersey - NJ": [
    "Newark", "Jersey City", "Paterson", "Elizabeth", "Edison",
    "Toms River", "Clifton", "Trenton", "Camden", "Passaic",
    "Union City", "Bayonne", "East Orange", "Vineland", "New Brunswick",
    "Hoboken", "Perth Amboy", "West New York", "Plainfield", "Other"
  ],
  "New Mexico - NM": [
    "Albuquerque", "Las Cruces", "Rio Rancho", "Santa Fe", "Roswell",
    "Farmington", "Clovis", "Hobbs", "Alamogordo", "Carlsbad",
    "Gallup", "Sunland Park", "Los Lunas", "Portales", "Lovington",
    "Silver City", "Artesia", "Deming", "Espanola", "Other"
  ],
  "New York - NY": [
    "New York City", "Buffalo", "Rochester", "Yonkers", "Syracuse",
    "Albany", "New Rochelle", "Mount Vernon", "Schenectady", "Utica",
    "White Plains", "Hempstead", "Troy", "Niagara Falls", "Binghamton",
    "Freeport", "Valley Stream", "Long Beach", "Poughkeepsie", "Other"
  ],
  "North Carolina - NC": [
    "Charlotte", "Raleigh", "Greensboro", "Durham", "Winston-Salem",
    "Fayetteville", "Cary", "Wilmington", "High Point", "Concord",
    "Greenville", "Asheville", "Gastonia", "Jacksonville", "Chapel Hill",
    "Rocky Mount", "Huntersville", "Apex", "Burlington", "Other"
  ],
  "North Dakota - ND": [
    "Fargo", "Bismarck", "Grand Forks", "Minot", "West Fargo",
    "Williston", "Dickinson", "Mandan", "Jamestown", "Wahpeton",
    "Devils Lake", "Valley City", "Grafton", "Lincoln", "Horace",
    "Rugby", "Beulah", "Stanley", "Casselton", "Other"
  ],
  "Ohio - OH": [
    "Columbus", "Cleveland", "Cincinnati", "Toledo", "Akron",
    "Dayton", "Parma", "Canton", "Youngstown", "Lorain",
    "Hamilton", "Springfield", "Kettering", "Elyria", "Lakewood",
    "Cuyahoga Falls", "Middletown", "Dublin", "Westerville", "Other"
  ],
 "Oklahoma - OK": [
    "Oklahoma City", "Tulsa", "Norman", "Broken Arrow", "Edmond",
    "Lawton", "Moore", "Midwest City", "Enid", "Stillwater",
    "Muskogee", "Bartlesville", "Owasso", "Shawnee", "Yukon",
    "Bixby", "Ardmore", "Ponca City", "Duncan", "Other"
  ],
  "Oregon - OR": [
    "Portland", "Eugene", "Salem", "Gresham", "Hillsboro",
    "Beaverton", "Bend", "Medford", "Springfield", "Corvallis",
    "Albany", "Tigard", "Lake Oswego", "Keizer", "Grants Pass",
    "Oregon City", "McMinnville", "Redmond", "Tualatin", "Other"
  ],
  "Pennsylvania - PA": [
    "Philadelphia", "Pittsburgh", "Allentown", "Erie", "Reading",
    "Scranton", "Bethlehem", "Lancaster", "Harrisburg", "York",
    "Altoona", "Wilkes-Barre", "Chester", "Williamsport", "Easton",
    "Lebanon", "Hazleton", "New Castle", "Johnstown", "Other"
  ],
  "Rhode Island - RI": [
    "Providence", "Cranston", "Warwick", "Pawtucket", "East Providence",
    "Woonsocket", "Cumberland", "Coventry", "North Providence", "South Kingstown",
    "West Warwick", "Johnston", "North Kingstown", "Newport", "Bristol",
    "Westerly", "Lincoln", "Central Falls", "Portsmouth", "Other"
  ],
  "South Carolina - SC": [
    "Charleston", "Columbia", "North Charleston", "Mount Pleasant", "Rock Hill",
    "Greenville", "Summerville", "Goose Creek", "Sumter", "Hilton Head Island",
    "Florence", "Spartanburg", "Myrtle Beach", "Aiken", "Anderson",
    "Greer", "Greenwood", "Mauldin", "North Augusta", "Other"
  ],
 "South Dakota - SD": [
    "Sioux Falls", "Rapid City", "Aberdeen", "Brookings", "Watertown",
    "Mitchell", "Yankton", "Pierre", "Huron", "Spearfish",
    "Vermillion", "Brandon", "Box Elder", "Madison", "Sturgis",
    "Harrisburg", "Tea", "Dell Rapids", "Hot Springs", "Other"
  ],
  "Tennessee - TN": [
    "Nashville", "Memphis", "Knoxville", "Chattanooga", "Clarksville",
    "Murfreesboro", "Franklin", "Jackson", "Johnson City", "Bartlett",
    "Hendersonville", "Kingsport", "Collierville", "Cleveland", "Smyrna",
    "Germantown", "Brentwood", "Spring Hill", "Cookeville", "Other"
  ],
  "Texas - TX": [
    "Houston", "San Antonio", "Dallas", "Austin", "Fort Worth",
    "El Paso", "Arlington", "Corpus Christi", "Plano", "Laredo",
    "Lubbock", "Garland", "Irving", "Amarillo", "Grand Prairie",
    "McKinney", "Frisco", "Brownsville", "Pasadena", "Other"
  ],
  "Utah - UT": [
    "Salt Lake City", "West Valley City", "Provo", "West Jordan", "Orem",
    "Sandy", "Ogden", "St. George", "Layton", "Taylorsville",
    "South Jordan", "Lehi", "Logan", "Murray", "Draper",
    "Bountiful", "Riverton", "Roy", "Spanish Fork", "Other"
  ],
  "Vermont - VT": [
    "Burlington", "South Burlington", "Rutland", "Barre", "Montpelier",
    "Essex Junction", "St. Albans", "Colchester", "Brattleboro", "Bennington",
    "Middlebury", "Milton", "Williston", "Hartford", "Springfield",
    "St. Johnsbury", "Winooski", "Northfield", "Morristown", "Other"
  ],
  "Virginia - VA": [
    "Virginia Beach", "Norfolk", "Chesapeake", "Arlington", "Richmond",
    "Newport News", "Alexandria", "Hampton", "Roanoke", "Portsmouth",
    "Suffolk", "Lynchburg", "Centreville", "Dale City", "Reston",
    "Harrisonburg", "Leesburg", "Charlottesville", "Manassas", "Other"
  ],
  "Washington - WA": [
    "Seattle", "Spokane", "Tacoma", "Vancouver", "Bellevue",
    "Kent", "Everett", "Renton", "Yakima", "Federal Way",
    "Spokane Valley", "Bellingham", "Kennewick", "Auburn", "Pasco",
    "Marysville", "Lakewood", "Redmond", "Shoreline", "Other"
  ],
  "West Virginia - WV": [
    "Charleston", "Huntington", "Morgantown", "Parkersburg", "Wheeling",
    "Weirton", "Fairmont", "Martinsburg", "Beckley", "Clarksburg",
    "South Charleston", "St. Albans", "Vienna", "Bluefield", "Oak Hill",
    "Moundsville", "Bridgeport", "Hurricane", "Elkins", "Other"
  ],
  "Wisconsin - WI": [
    "Milwaukee", "Madison", "Green Bay", "Kenosha", "Racine",
    "Appleton", "Waukesha", "Eau Claire", "Oshkosh", "Janesville",
    "West Allis", "La Crosse", "Sheboygan", "Wauwatosa", "Fond du Lac",
    "New Berlin", "Wausau", "Brookfield", "Beloit", "Other"
  ],
  "Wyoming - WY": [
    "Cheyenne", "Casper", "Laramie", "Gillette", "Rock Springs",
    "Sheridan", "Green River", "Evanston", "Riverton", "Jackson",
    "Cody", "Rawlins", "Lander", "Torrington", "Powell",
    "Douglas", "Worland", "Buffalo", "Thermopolis", "Other"
  ],

  // Territories
  "Puerto Rico - PR": [
    "San Juan", "Bayamón", "Carolina", "Ponce", "Caguas",
    "Guaynabo", "Arecibo", "Toa Baja", "Mayagüez", "Trujillo Alto",
    "Fajardo", "Vega Baja", "Cataño", "Humacao", "Manatí",
    "Cayey", "Isabela", "San Sebastián", "Yauco", "Other"
  ],
  "Guam - GU": [
    "Hagåtña", "Tamuning", "Dededo", "Mongmong-Toto-Maite", "Yigo",
    "Mangilao", "Barrigada", "Chalan Pago-Ordot", "Agat", "Santa Rita",
    "Yona", "Umatac", "Inarajan", "Merizo", "Piti",
    "Asan", "Sinajana", "Maina", "Anigua", "Other"
  ],
  "U.S. Virgin Islands - VI": [
    "Charlotte Amalie", "Christiansted", "Frederiksted", "Cruz Bay", "Coral Bay",
    "East End", "Northside", "West End", "Anna's Retreat", "Pearl",
    "Peter's Rest", "Smith Bay", "Contant", "Kingshill", "Castle Coakley",
    "Lovenlund", "Pearl City", "Hull Bay", "Water Island", "Other"
  ],
  "American Samoa - AS": [
    "Pago Pago", "Tafuna", "Nu'uuli", "Fagatogo", "Leone",
    "Faleniu", "Aua", "Mapusagafou", "Vaitogi", "Fagasa",
    "Utulei", "Pava'ia'i", "Aoloau", "Amouli", "Leloaloa",
    "Ofu", "Olosega", "Ta'u", "Malaeimi", "Other"
  ],
  "Northern Mariana Islands - MP": [
    "Saipan", "Tinian", "Rota", "San Jose", "San Vicente",
    "Kagman", "Susupe", "Garapan", "Chalan Kanoa", "Tanapag",
    "San Roque", "Capitol Hill", "Papago", "Dandan", "As Lito",
    "Koblerville", "Afetnas", "Gualo Rai", "Santa Lourdes", "Other"
  ],
};

 export const IndiaStates = [
   { "label": "Select State", "value": "" },
  { "label": "Andaman and Nicobar Islands - AN", "value": "Andaman and Nicobar Islands - AN" },
  { "label": "Andhra Pradesh - AP", "value": "Andhra Pradesh - AP" },
  { "label": "Arunachal Pradesh - AR", "value": "Arunachal Pradesh - AR" },
  { "label": "Assam - AS", "value": "Assam - AS" },
  { "label": "Bihar - BR", "value": "Bihar - BR" },
  { "label": "Chandigarh - CH", "value": "Chandigarh - CH" },
  { "label": "Chhattisgarh - CT", "value": "Chhattisgarh - CT" },
  { "label": "Dadra and Nagar Haveli and Daman and Diu - DH", "value": "Dadra and Nagar Haveli and Daman and Diu - DH" },
  { "label": "Delhi - DL", "value": "Delhi - DL" },
  { "label": "Goa - GA", "value": "Goa - GA" },
  { "label": "Gujarat - GJ", "value": "Gujarat - GJ" },
  { "label": "Haryana - HR", "value": "Haryana - HR" },
  { "label": "Himachal Pradesh - HP", "value": "Himachal Pradesh - HP" },
  { "label": "Jammu and Kashmir - JK", "value": "Jammu and Kashmir - JK" },
  { "label": "Jharkhand - JH", "value": "Jharkhand - JH" },
  { "label": "Karnataka - KA", "value": "Karnataka - KA" },
  { "label": "Kerala - KL", "value": "Kerala - KL" },
  { "label": "Ladakh - LA", "value": "Ladakh - LA" },
  { "label": "Lakshadweep - LD", "value": "Lakshadweep - LD" },
  { "label": "Madhya Pradesh - MP", "value": "Madhya Pradesh - MP" },
  { "label": "Maharashtra - MH", "value": "Maharashtra - MH" },
  { "label": "Manipur - MN", "value": "Manipur - MN" },
  { "label": "Meghalaya - ML", "value": "Meghalaya - ML" },
  { "label": "Mizoram - MZ", "value": "Mizoram - MZ" },
  { "label": "Nagaland - NL", "value": "Nagaland - NL" },
  { "label": "Odisha - OR", "value": "Odisha - OR" },
  { "label": "Puducherry - PY", "value": "Puducherry - PY" },
  { "label": "Punjab - PB", "value": "Punjab - PB" },
  { "label": "Rajasthan - RJ", "value": "Rajasthan - RJ" },
  { "label": "Sikkim - SK", "value": "Sikkim - SK" },
  { "label": "Tamil Nadu - TN", "value": "Tamil Nadu - TN" },
  { "label": "Telangana - TG", "value": "Telangana - TG" },
  { "label": "Tripura - TR", "value": "Tripura - TR" },
  { "label": "Uttar Pradesh - UP", "value": "Uttar Pradesh - UP" },
  { "label": "Uttarakhand - UK", "value": "Uttarakhand - UK" },
  { "label": "West Bengal - WB", "value": "West Bengal - WB" }
];
export const IndiaStateCities = {
  "Andaman and Nicobar Islands - AN": [
    "Port Blair", "Diglipur", "Mayabunder", "Rangat", "Neil Island",
    "Havelock Island", "Car Nicobar", "Katchal", "Kamorta", "Campbell Bay",
    "Little Andaman", "Great Nicobar", "Long Island", "Bamboo Flat", "Garacharma",
    "Wimberlygunj", "Prothrapur", "Ferrargunj", "Barren Island", "Other"
  ],
  "Andhra Pradesh - AP": [
    "Visakhapatnam", "Vijayawada", "Guntur", "Tirupati", "Kurnool",
    "Nellore", "Rajahmundry", "Kakinada", "Anantapur", "Kadapa",
    "Chittoor", "Ongole", "Eluru", "Srikakulam", "Vizianagaram",
    "Machilipatnam", "Proddatur", "Hindupur", "Adoni", "Nandyal", "Other"
  ],
  "Arunachal Pradesh - AR": [
    "Itanagar", "Naharlagun", "Tawang", "Pasighat", "Ziro",
    "Roing", "Aalo", "Bomdila", "Seppa", "Khonsa",
    "Tezu", "Changlang", "Namsai", "Yingkiong", "Daporijo",
    "Anini", "Longding", "Koloriang", "Miao", "Other"
  ],
  "Assam - AS": [
    "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Tezpur",
    "Nagaon", "Tinsukia", "Goalpara", "Barpeta", "Sivasagar",
    "Dhubri", "Karimganj", "Hailakandi", "Lakhimpur", "Golaghat",
    "Bongaigaon", "Morigaon", "Diphu", "North Lakhimpur", "Other"
  ],
  "Bihar - BR": [
    "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia",
    "Darbhanga", "Ara", "Begusarai", "Katihar", "Chapra",
    "Saharsa", "Munger", "Bettiah", "Siwan", "Samastipur",
    "Motihari", "Nalanda", "Jehanabad", "Buxar", "Kishanganj", "Other"
  ],
  "Chandigarh - CH": [
    "Chandigarh", "Manimajra", "Daria", "Raipur Kalan", "Hallo Majra",
    "Sarangpur", "Dhanas", "Madhya Marg", "Sector 17", "Sector 22",
    "Sector 15", "Sector 34", "Sector 43", "Sector 44", "Sector 47",
    "Sector 63", "Sector 61", "Sector 48", "Sector 20", "Other"
  ],
  "Chhattisgarh - CT": [
    "Raipur", "Bhilai", "Bilaspur", "Korba", "Durg",
    "Rajnandgaon", "Jagdalpur", "Ambikapur", "Raigarh", "Mahasamund",
    "Kawardha", "Dhamtari", "Janjgir", "Kanker", "Dongargarh",
    "Manendragarh", "Kondagaon", "Sukma", "Bemetara", "Baloda Bazar", "Other"
  ],
  "Dadra and Nagar Haveli and Daman and Diu - DH": [
    "Daman", "Silvassa", "Diu", "Khanvel", "Naroli",
    "Dadra", "Samarvarni", "Rakholi", "Vapi (nearby)", "Kachigam",
    "Dunetha", "Marwad", "Bhilad", "Moti Daman", "Kadaiya",
    "Jampore", "Varkund", "Ringanwada", "Zaroli", "Other"
  ],
  "Delhi - DL": [
    "New Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh",
    "Connaught Place", "Lajpat Nagar", "Mayur Vihar", "Vasant Kunj", "Janakpuri",
    "Pitampura", "Shahdara", "Okhla", "Narela", "Palam",
    "Rajouri Garden", "Chanakyapuri", "Greater Kailash", "Chandni Chowk", "Other"
  ],
  "Goa - GA": [
    "Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda",
    "Bicholim", "Curchorem", "Quepem", "Sanguem", "Canacona",
    "Aldona", "Calangute", "Colva", "Anjuna", "Candolim",
    "Siolim", "Porvorim", "Tivim", "Dona Paula", "Other"
  ],
  "Gujarat - GJ": [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar",
    "Jamnagar", "Junagadh", "Anand", "Nadiad", "Gandhinagar",
    "Morbi", "Bharuch", "Navsari", "Valsad", "Veraval",
    "Surendranagar", "Patan", "Porbandar", "Godhra", "Mehsana", "Other"
  ],
  "Haryana - HR": [
    "Gurugram", "Faridabad", "Panipat", "Ambala", "Karnal",
    "Hisar", "Rohtak", "Sonipat", "Yamunanagar", "Sirsa",
    "Bahadurgarh", "Bhiwani", "Jind", "Rewari", "Palwal",
    "Kaithal", "Kurukshetra", "Fatehabad", "Jhajjar", "Mahendragarh", "Other"
  ],
  "Himachal Pradesh - HP": [
    "Shimla", "Dharamshala", "Manali", "Solan", "Mandi",
    "Kullu", "Hamirpur", "Una", "Bilaspur", "Chamba",
    "Kangra", "Nahan", "Paonta Sahib", "Palampur", "Dalhousie",
    "Sundarnagar", "Keylong", "Rampur", "Reckong Peo", "Kinnaur", "Other"
  ],
  "Jammu and Kashmir - JK": [
    "Srinagar", "Jammu", "Anantnag", "Baramulla", "Kathua",
    "Udhampur", "Pulwama", "Kupwara", "Rajouri", "Poonch",
    "Bandipora", "Budgam", "Shopian", "Kulgam", "Handwara",
    "Reasi", "Sopore", "Awantipora", "Doda", "Kishtwar", "Other"
  ],
  "Jharkhand - JH": [
    "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh",
    "Deoghar", "Giridih", "Ramgarh", "Chaibasa", "Dumka",
    "Godda", "Palamu", "Chatra", "Seraikela", "Latehar",
    "Pakur", "Simdega", "Lohardaga", "Koderma", "Phusro", "Other"
  ],
  "Karnataka - KA": [
    "Bengaluru", "Mysuru", "Mangaluru", "Hubli", "Belagavi",
    "Davanagere", "Ballari", "Tumakuru", "Shivamogga", "Kalaburagi",
    "Raichur", "Bidar", "Udupi", "Hassan", "Chitradurga",
    "Karwar", "Kolar", "Bagalkot", "Hospet", "Mandya", "Other"
  ],
  "Kerala - KL": [
    "Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam",
    "Alappuzha", "Palakkad", "Kannur", "Kottayam", "Malappuram",
    "Pathanamthitta", "Kasargod", "Idukki", "Nedumangad", "Perinthalmanna",
    "Ponnani", "Chalakudy", "Payyannur", "Kayamkulam", "Muvattupuzha", "Other"
  ],
  "Ladakh - LA": [
    "Leh", "Kargil", "Diskit", "Nubra", "Zanskar",
    "Drass", "Padum", "Khaltsi", "Tangtse", "Nyoma",
    "Chuchot", "Thiksey", "Sanku", "Shakar Chiktan", "Wanla",
    "Hanle", "Changthang", "Sham Valley", "Hemis", "Other"
  ],
  "Lakshadweep - LD": [
    "Kavaratti", "Agatti", "Andrott", "Minicoy", "Amini",
    "Kalpeni", "Kadmat", "Chetlat", "Kiltan", "Bitra",
    "Suheli", "Bangaram", "Thinnakara", "Cheriyam", "Parali 1",
    "Parali 2", "Parali 3", "Pitti", "Suheli Par", "Other"
  ],
  "Madhya Pradesh - MP": [
    "Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain",
    "Sagar", "Satna", "Rewa", "Dewas", "Ratlam",
    "Chhindwara", "Khandwa", "Burhanpur", "Bhind", "Morena",
    "Shivpuri", "Hoshangabad", "Sehore", "Mandsaur", "Neemuch", "Other"
  ],
  "Maharashtra - MH": [
    "Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad",
    "Solapur", "Amravati", "Kolhapur", "Sangli", "Jalgaon",
    "Akola", "Latur", "Ahmednagar", "Dhule", "Satara",
    "Chandrapur", "Parbhani", "Beed", "Wardha", "Ratnagiri", "Other"
  ],
  "Manipur - MN": [
    "Imphal", "Thoubal", "Kakching", "Ukhrul", "Churachandpur",
    "Senapati", "Tamenglong", "Bishnupur", "Jiribam", "Kangpokpi",
    "Moreh", "Noney", "Pherzawl", "Tengnoupal", "Kumbi",
    "Lamlai", "Wangjing", "Sugnu", "Heirok", "Other"
  ],
  "Meghalaya - ML": [
    "Shillong", "Tura", "Jowai", "Nongpoh", "Williamnagar",
    "Baghmara", "Resubelpara", "Mairang", "Mawkyrwat", "Khliehriat",
    "Nongstoin", "Ampati", "Rongjeng", "Cherrapunjee", "Mawsynram",
    "Mawlai", "Pynursla", "Umiam", "Mawphlang", "Other"
  ],
  "Mizoram - MZ": [
    "Aizawl", "Lunglei", "Saiha", "Champhai", "Serchhip",
    "Kolasib", "Mamit", "Lawngtlai", "Hnahthial", "North Vanlaiphai",
    "Sairang", "Zawlnuam", "Khawzawl", "Biate", "Khawhai",
    "Thingsulthliah", "Reiek", "Vairengte", "Tlabung", "Other"
  ],
  "Nagaland - NL": [
    "Kohima", "Dimapur", "Mokokchung", "Wokha", "Mon",
    "Tuensang", "Phek", "Zunheboto", "Kiphire", "Longleng",
    "Chumukedima", "Medziphema", "Pfutsero", "Tseminyu", "Bhandari",
    "Meluri", "Noklak", "Aghunato", "Changtongya", "Other"
  ],
  "Odisha - OR": [
    "Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur", "Puri",
    "Balasore", "Baripada", "Berhampur", "Angul", "Jharsuguda",
    "Bolangir", "Kendujhar", "Rayagada", "Koraput", "Kalahandi",
    "Jeypore", "Bhawanipatna", "Jagatsinghpur", "Paradeep", "Dhenkanal", "Other"
  ],
  "Puducherry - PY": [
    "Puducherry", "Karaikal", "Mahe", "Yanam", "Oulgaret",
    "Villiyanur", "Bahour", "Nettapakkam", "Ariyankuppam", "Kurumbapet",
    "Manavely", "Kottucherry", "Nedungadu", "Tirumalairayanpattinam", "Thirunallar",
    "Thirubuvanai", "Kalapet", "Nonankuppam", "Lawspet", "Other"
  ],
  "Punjab - PB": [
    "Amritsar", "Ludhiana", "Jalandhar", "Patiala", "Bathinda",
    "Mohali", "Hoshiarpur", "Moga", "Firozpur", "Pathankot",
    "Sangrur", "Barnala", "Khanna", "Phagwara", "Malerkotla",
    "Rupnagar", "Faridkot", "Kapurthala", "Abohar", "Muktsar", "Other"
  ],
  "Rajasthan - RJ": [
    "Jaipur", "Udaipur", "Jodhpur", "Kota", "Ajmer",
    "Bikaner", "Alwar", "Sikar", "Bhilwara", "Bharatpur",
    "Pali", "Tonk", "Barmer", "Chittorgarh", "Nagaur",
    "Jaisalmer", "Jhunjhunu", "Dausa", "Hanumangarh", "Sri Ganganagar", "Other"
  ],
  "Sikkim - SK": [
    "Gangtok", "Namchi", "Geyzing", "Mangan", "Singtam",
    "Rangpo", "Jorethang", "Yuksom", "Pelling", "Ravangla",
    "Chungthang", "Singtam", "Singtam", "Singtam (repeat filler)", "Other",
    "Dentam", "Soreng", "Lachen", "Lachung", "Zuluk", "Other"
  ],
  "Tamil Nadu - TN": [
    "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem",
    "Erode", "Tirunelveli", "Vellore", "Thoothukudi", "Nagercoil",
    "Thanjavur", "Dindigul", "Karur", "Krishnagiri", "Cuddalore",
    "Kanchipuram", "Nagapattinam", "Sivakasi", "Pudukkottai", "Virudhunagar", "Other"
  ],
  "Telangana - TG": [
    "Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam",
    "Ramagundam", "Mahbubnagar", "Adilabad", "Suryapet", "Miryalaguda",
    "Nalgonda", "Mancherial", "Sangareddy", "Jagtial", "Bodhan",
    "Zaheerabad", "Kothagudem", "Wanaparthy", "Nagarkurnool", "Other"
  ],
  "Tripura - TR": [
    "Agartala", "Udaipur", "Kailashahar", "Dharmanagar", "Ambassa",
    "Belonia", "Khowai", "Sonamura", "Teliamura", "Bishalgarh",
    "Melaghar", "Sabroom", "Ranirbazar", "Jirania", "Panisagar",
    "Jampuijala", "Santirbazar", "Amarpur", "Kamalpur", "Other"
  ],
  "Uttar Pradesh - UP": [
    "Lucknow", "Kanpur", "Varanasi", "Agra", "Prayagraj",
    "Ghaziabad", "Noida", "Meerut", "Bareilly", "Aligarh",
    "Moradabad", "Saharanpur", "Gorakhpur", "Jhansi", "Firozabad",
    "Muzaffarnagar", "Mathura", "Ayodhya", "Shahjahanpur", "Rampur", "Other"
  ],
  "Uttarakhand - UK": [
    "Dehradun", "Haridwar", "Rishikesh", "Haldwani", "Kashipur",
    "Rudrapur", "Roorkee", "Almora", "Pithoragarh", "Nainital",
    "Mussoorie", "Tehri", "Kotdwar", "Bageshwar", "Champawat",
    "Lansdowne", "Joshimath", "Kedarnath", "Badrinath", "Other"
  ],
  "West Bengal - WB": [
    "Kolkata", "Asansol", "Siliguri", "Durgapur", "Howrah",
    "Kharagpur", "Haldia", "Jalpaiguri", "Malda", "Bardhaman",
    "Krishnanagar", "Cooch Behar", "Medinipur", "Bankura", "Alipurduar",
    "Santiniketan", "Raiganj", "Balurghat", "Chandannagar", "Serampore", "Other"
  ]
};

export const employmentTypeOptions = [
  { value: "full-time", label: "Full-time" },
  { value: "contract - w2", label: "Contract - W2" },
  { value: "contract to hire - w2", label: "Contract to Hire - W2" },
  { value: "contract to hire - independent", label: "Contract to Hire - Independent" },
  { value: "contract - independent", label: "Contract - Independent" },
  { value: "part-time", label: "Part-time" },
  { value: "contract to hire - corp-to-corp", label: "Contract to Hire - Corp-to-Corp" },
  { value: "contract - corp-to-corp", label: "Contract - Corp-to-Corp" },
  { value: "1099 employee", label: "1099 Employee" },
  { value: "announced", label: "Announced" },
  { value: "corp-to-corp", label: "Corp-to-Corp" },
  { value: "eb-1", label: "EB-1" },
  { value: "eb-2", label: "EB-2" },
  { value: "eb-3", label: "EB-3" },
  { value: "h-1b", label: "H-1B" },
  { value: "h-4", label: "H-4" },
  { value: "independent", label: "Independent" },
  { value: "j-1", label: "J-1" },
  { value: "j-2", label: "J-2" },
  { value: "tax term", label: "Tax Term" },
  { value: "w-2", label: "W-2" },
  { value: "w-2 / 1099", label: "W-2 / 1099" },
];

export const workPermitOptions = [
  { value: "us citizenship", label: "US Citizenship" },
  { value: "green card", label: "Green Card" },
  { value: "employment auth document", label: "Employment Auth Document" },
  { value: "have h1", label: "Have H1" },
  { value: "need h1", label: "Need H1" },
  { value: "canadian citizen", label: "Canadian Citizen" },
  { value: "tn permit holder", label: "TN Permit Holder" },
  { value: "unspecified", label: "Unspecified" },
];




 




 
 
 
 
 































